import { MyWindow } from 'react-app-env';
import { STORAGE_KEY_ENUM } from 'enums';
import { ReactNode, useEffect } from 'react';

declare const window: MyWindow;

type VersionProviderProps = {
  children: ReactNode;
};

const VersionProvider = ({ children }: VersionProviderProps) => {
  useEffect(() => {
    const currentVersion = window.config.version;
    const appVersion = localStorage.getItem(STORAGE_KEY_ENUM.VERSION);

    const path = window.location.pathname;

    const publicPrefixes = ['/confirm-effort/'];
    const isPublic = publicPrefixes.some((p) => path.startsWith(p));

    if (currentVersion && appVersion !== currentVersion) {
      localStorage.removeItem(STORAGE_KEY_ENUM.VERSION);
      localStorage.setItem(STORAGE_KEY_ENUM.VERSION, currentVersion);

      if (!isPublic) {
        setTimeout(() => {
          window.location.href = '/';
        }, 100);
      }
    }
  }, []);
  return <>{children}</>;
};

export default VersionProvider;
